import { Inertia } from '@inertiajs/inertia'

export default function(inertia){

    function logout(){
        Inertia.post(route("logout"))
    }

    return {
        logout
    }
}